export default __webpack_public_path__ + "locales/en/DownloadDialog.json?hash=4f52d95b087d4a052ff86e901dd40a8c";